export default __webpack_public_path__ + "static/SectionTwo_02_03-c1a93c6872da43d3a732e469f4333e38.png";